var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isOpen)?_c('AgencyDetailsDialog',{attrs:{"agencyDetails":_vm.agency,"is-open":_vm.isOpen,"title":"Edit Agency","actionName":"Save Changes","loading":_vm.isLoading},on:{"close":_vm.closeNewAgencyDialog,"submit":_vm.onSubmit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }